import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { MySACommon, MyCompany, MyConfig, DynamicInstance } from 'src/app/model/systemadmin';
import { Globals } from '../globals';
@Injectable({
  providedIn: 'root'
})
export class SystemadminService {

    constructor(private http: HttpClient, private globals: Globals) { }
    public authToken = "";

    loadToken() {
        const token = localStorage.getItem('Token');
        this.authToken = token;
    }
    createAuthHeader() {
        this.loadToken();
        const headers = new HttpHeaders().set(
            'Authorization',
            `Bearer ${this.authToken}`
        );
        return { headers };
    }

    GetCountries(OL: MySACommon): Observable<MySACommon[]> {
        return this.http.post<MySACommon[]>(this.globals.APISAURL + '/SystemAdminApi/GetCountries', OL, this.createAuthHeader());
    }

    GetState(OL: MySACommon): Observable<MySACommon[]> {
        return this.http.post<MySACommon[]>(this.globals.APISAURL + '/SystemAdminApi/GetState', OL, this.createAuthHeader());
    }

    GetStates(OL: MySACommon): Observable<MySACommon[]> {
        return this.http.post<MySACommon[]>(this.globals.APISAURL + '/SystemAdminApi/GetStates', OL, this.createAuthHeader());
    }

    GetCity(OL: MySACommon): Observable<MySACommon[]> {
        return this.http.post<MySACommon[]>(this.globals.APISAURL + '/SystemAdminApi/GetCity', OL, this.createAuthHeader());
    }

    GetCities(OL: MySACommon): Observable<MySACommon[]> {
        return this.http.post<MySACommon[]>(this.globals.APISAURL + '/SystemAdminApi/GetCities', OL, this.createAuthHeader());
    }

   //// GetPort(OL: MySACommon): Observable<MySACommon[]> {
   //     return this.http.post<MySACommon[]>(this.globals.APISAURL + '/SystemAdminApi/GetPort', OL, this.createAuthHeader());
   // }

    GetTerminal(OL: MySACommon): Observable<MySACommon[]> {
        return this.http.post<MySACommon[]>(this.globals.APISAURL + '/SystemAdminApi/GetTerminal', OL, this.createAuthHeader());
    }

    GetShipmentLocation(OL: MySACommon): Observable<MySACommon[]> {
        return this.http.post<MySACommon[]>(this.globals.APISAURL + '/SystemAdminApi/GetShipmentLocation', OL, this.createAuthHeader());
    }

    GetShipmentLocations(OL: MySACommon): Observable<MySACommon[]> {
        return this.http.post<MySACommon[]>(this.globals.APISAURL + '/SystemAdminApi/GetShipmentLocations', OL, this.createAuthHeader());
    }

    GetCommodities(OL: MySACommon): Observable<MySACommon[]> {
        return this.http.post<MySACommon[]>(this.globals.APISAURL + '/SystemAdminApi/GetCommodities', OL, this.createAuthHeader());
    }

    GetPackageTypes(OL: MySACommon): Observable<MySACommon[]> {
        return this.http.post<MySACommon[]>(this.globals.APISAURL + '/SystemAdminApi/GetPackageTypes', OL, this.createAuthHeader());
    }

    GetContainerTypes(OL: MySACommon): Observable<MySACommon[]> {
        return this.http.post<MySACommon[]>(this.globals.APISAURL + '/SystemAdminApi/GetContainerTypes', OL, this.createAuthHeader());
    }

    GetHazClasses(OL: MySACommon): Observable<MySACommon[]> {
        return this.http.post<MySACommon[]>(this.globals.APISAURL + '/SystemAdminApi/GetHazClasses', OL, this.createAuthHeader());
    }

    GetCompanyDetails(OL: MyCompany): Observable<MyCompany[]> {
        return this.http.post<MyCompany[]>(this.globals.APISAURL + '/SystemAdminApi/GetCompanyDetails', OL, this.createAuthHeader());
    }
    GetCurrencyDetails(OL: MySACommon): Observable<MySACommon[]> {
        return this.http.post<MySACommon[]>(this.globals.APISAURL + '/SystemAdminApi/GetCurrency', OL, this.createAuthHeader());
    }



    saveCompany(OD: MyCompany) {

        return this.http.post(this.globals.APISAURL + '/SystemAdminApi/SaveCompany/', OD);
    }

    GetCompanyView(OL: MyCompany): Observable<MyCompany[]> {
        return this.http.post<MyCompany[]>(this.globals.APIURL + '/SystemAdminApi/GetCompanyView', OL, this.createAuthHeader());
    }
    GetCompanyEdit(OL: MyCompany): Observable<MyCompany[]> {
        return this.http.post<MyCompany[]>(this.globals.APIURL + '/SystemAdminApi/GetCompanyEdit', OL, this.createAuthHeader());
    }  
    SaveConfig(OD: MyConfig) {

        return this.http.post(this.globals.APIURL + '/SystemAdminApi/SaveConfig/', OD);
    }
    GetConfigEdit(OL: MyConfig): Observable<MyConfig[]> {
        return this.http.post<MyConfig[]>(this.globals.APIURL + '/SystemAdminApi/GetConfigEdit', OL, this.createAuthHeader());
    }

    //Only ICD and Sea Port 
    GetPort(OL: MySACommon): Observable<MySACommon[]> {
        return this.http.post<MySACommon[]>(this.globals.APIURL + '/enquiryApi/GetPort', OL, this.createAuthHeader());
    }

    GetSeaPort(OL: MySACommon): Observable<MySACommon[]> {
        return this.http.post<MySACommon[]>(this.globals.APISAURL + '/SystemAdminApi/GetSeaPorts', OL, this.createAuthHeader());
    }

    GetInstanceLinks(OL: DynamicInstance): Observable<DynamicInstance[]> {
        return this.http.post<DynamicInstance[]>(this.globals.APISAURL + '/SystemAdminApi/InstanceLinks', OL, this.createAuthHeader());
    }

}
